module.exports = __webpack_public_path__ + "static/media/time-icon-active.a0fa5cff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/time-icon-active.svg
// module id = 1863
// module chunks = 0